<template>
  <div id="routerMenu">
    <!-- 登陆入口 -->
    <div class="routerMenu_isLogo" v-if="token === false">
      <img src="../assets/images/slices/pay.png" alt="" />
      <h2>{{ $t("menu.RouterMenu_Welcome") }}</h2>
      <p>{{ $t("menu.RouterMenu_experience") }}</p>
      <div @click="goLogin" :style="{ opacity: loading ? '0.25' : '1' }">
        {{ $t("nav.login") }}
        <img
          class="icon"
          src="../assets/images/direction-icon/rightIconSell.png"
          alt=""
          v-if="!loading"
        />
        <van-loading class="icon" type="spinner" color="#fff" v-else />
      </div>
    </div>
    <!-- 交易历史入口 -->
    <div
      class="routerMenu_history"
      @click="goView('/tradeHistory')"
      v-if="token === true"
    >
      <div class="lineIcon">
        <img src="../assets/images/slices/histry.png" />
      </div>
      <div class="lineName">
        <p class="alone">{{ $t("menu.transactions") }}</p>
      </div>
      <div class="lineRight">
        <div><img src="../assets/images/slices/right_icon.png" /></div>
      </div>
    </div>
    <!-- 语言展示、入口  -->
    <div
      class="routerMenu_line"
      style="margin-top: 0.28rem"
      @click="openLanguage"
    >
      <div class="lineIcon">
        <img src="../assets/images/slices/iconLang.png" />
      </div>
      <div class="lineName">{{ $t("menu.language") }}</div>
      <div class="lineRight">
        <p>{{ languageName() }}</p>
        <div><img src="../assets/images/slices/right_icon.png" /></div>
      </div>
    </div>
    <!-- 协议入口 -->
    <div class="routerMenu_line" @click="goProtocol('termsUse')">
      <div class="lineIcon">
        <img src="../assets/images/slices/terms.png" />
      </div>
      <div class="lineName">{{ $t("menu.service") }}</div>
      <div class="lineRight">
        <div><img src="../assets/images/slices/right_icon.png" /></div>
      </div>
    </div>
    <div class="routerMenu_line" @click="goProtocol('privacyPolicy')">
      <div class="lineIcon">
        <img src="../assets/images/slices/privacy.png" />
      </div>
      <div class="lineName">{{ $t("menu.privacy") }}</div>
      <div class="lineRight">
        <div><img src="../assets/images/slices/right_icon.png" /></div>
      </div>
    </div>
    <!-- 退出登陆入口 -->
    <div
      class="routerMenu_line"
      @click="loginOutIsShow"
      v-if="email !== ''"
      style="display: flex; justify-content: space-between"
    >
      <div style="display: flex; align-items: center">
        <div class="lineIcon">
          <img src="../assets/images/slices/logOut.png" />
        </div>
        <div class="lineName">{{ $t("menu.logOut") }}</div>
      </div>
      <div class="lineRight" style="margin: 0">
        <div
          class="email"
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 0.2rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #6e7687;
          "
        >
          <img
            v-if="kycCertified"
            style="margin-right: 0.02rem"
            :src="kycPassed"
            alt=""
          />
          <img
            v-else
            style="margin-right: 0.02rem"
            :src="
              disAbled === true ? kycError : disAbled === false ? kycSess : ''
            "
            alt=""
          />{{ emailSlice }}
        </div>
        <div><img src="../assets/images/slices/right_icon.png" /></div>
      </div>
    </div>
    <!-- 退出登陆确认弹框 -->
    <div class="routerMenu_loginOut" v-show="show" @click="show = false">
      <div class="content" ref="loginOutView" @click.stop="show = true">
        <h2>{{ $t("menu.loginOut_title") }}</h2>
        <div>
          <button @click.stop="outLogin" :disabled="loginOutLoading">
            {{ $t("menu.logOut") }}
            <van-loading
              v-if="loginOutLoading"
              class="icon"
              type="spinner"
              color="#fff"
            />
          </button>
          <p @click.stop="show = false">{{ $t("menu.loginOut_Dismiss") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 菜单组件
 */
import { AES_Decrypt } from "@/utils/encryp";
import { mapState } from "vuex";

export default {
  name: "routerMenu",
  data() {
    return {
      email: "",
      token: false,
      show: false,
      loading: false,
      query: {
        pageIndex: 1,
        pageSize: 5,
        historyList: [],
        showAll: true,
      },

      disAbled: "",
      kycError: require("@/assets/images/icons/AccountRisk.png"),
      kycSess: require("@/assets/images/icons/kycScuss.png"),
      kycPassed: require("@/assets/images/kycOnfido/kycPassed.svg"),
      loginOutLoading: false,
    };
  },
  activated() {
    localStorage.getItem("token") ? (this.token = true) : (this.token = false);
    localStorage.getItem("email")
      ? (this.email = AES_Decrypt(localStorage.getItem("email")))
      : (this.email = "");
  },
  deactivated() {
    localStorage.getItem("token") ? (this.token = true) : (this.token = false);
    localStorage.getItem("email")
      ? (this.email = AES_Decrypt(localStorage.getItem("email")))
      : (this.email = "");
  },
  methods: {
    //Select menu
    goView(name) {
      //首页打开菜单 跳转交易历史 交易历史返回到菜单
      if (name === "/tradeHistory") {
        this.$parent.routerViewState = true;
        this.$router.push(name);
        return;
      }

      this.$parent.routerViewState = true;
      this.$parent.menuState = false;

      if (name === "/") {
        //清空页面状态
        this.$store.commit("public/set_creditCard_backState", false);

        this.$parent.routerViewState = true;
        this.$store.commit("public/set_menuState2", true);
        this.$router.push(name);
        setTimeout(() => {
          this.$parent.$refs.routerView
            ? (this.$parent.$refs.routerView.menuState = false)
            : "";
        }, 100);
        return;
      }

      if (name === "Language") {
        this.$router.push(name);
        return;
      }

      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") === ""
      ) {
        this.$store.commit("public/set_emailFromPath", this.$parent.tabstate);
        this.$router.push("/emailCode?fromName=tradeList").catch(() => {});
      } else {
        this.$router.push(name);
      }
    },
    onClose() {
      this.show = false;
    },
    //语言栏显示切换语言
    languageName() {
      let language = sessionStorage.getItem("language")
        ? sessionStorage.getItem("language")
        : "en-US";
      let LanguageName = "";
      for (let item of Object.keys(this.$i18n.messages)) {
        if (item === language) {
          LanguageName = this.$i18n.messages[item].language;
        }
      }
      return LanguageName;
    },

    //Exit the login hidden menu and clear the login information
    outLogin() {
      if (this.email && !this.loginOutLoading) {
        this.loginOutLoading = true;
        this.$axios
          .post(this.$api.post_outLogin, "", "")
          .then((res) => {
            if (res) {
              localStorage.removeItem("sign");
              localStorage.removeItem("token");
              localStorage.removeItem("email");
              localStorage.setItem("loginOut", "1");
              localStorage.removeItem("kycStatus");
              sessionStorage.removeItem("store");
              this.loginOutLoading = false;
              this.show = false;
              if (this.$route.path !== "/") {
                this.$parent.routerViewState = true;
                // setTimeout(()=>{
                //   this.$parent.routerViewState = false
                // },200)
                this.$router.replace("/").then(() => {
                  this.$parent.menuState = true;
                  try {
                    this.$parent.queryInfo();
                  } catch (e) {
                    console.log(e);
                  }
                });
                return;
              }
              this.token = false;
              this.email = "";
            }
          })
          .catch(() => {
            this.loginOutLoading = false;
          });
      }
    },

    //协议跳转
    goProtocol(name) {
      if (name === "privacyPolicy") {
        window.location = "https://alchemypay.org/privacy-policy/";
        return;
      }
      if (name === "termsUse") {
        window.location = "https://alchemypay.org/terms-of-use/";
      }
    },

    goLogin() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.$store.commit("changeRouterQueryPath", true);
        this.$parent.routerViewState = true;
        //是否是从菜单进入
        this.$router.push("/emailCode");
      }, 200);
    },
    //显示退出登陆判断是否是pc 还是 移动
    loginOutIsShow() {
      let winWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      if (winWidth < 791) {
        this.$refs.loginOutView.style =
          "top:20%;tannsfrom:translate(-50%,-20%)";
      } else {
        this.$refs.loginOutView.style =
          "left:50%;top:30%;tannsfrom:translate(-50%,-30%)";
      }
      this.show = true;
    },
    //语言切换的显示隐藏
    openLanguage() {
      this.$store.commit("public/set_languageIsShow", true);
    },
  },
  computed: {
    emailSlice() {
      let email = this.email;
      let email1 =
        email.slice(0, 3) +
        " *** " +
        email.slice(email.indexOf("@"), email.indexOf("@") + 6) +
        "...";
      return email1;
    },
    ...mapState("public", {
      menuState: (state) => state.menuState,
      languageIsShow: (state) => state.languageIsShow,
    }),
    ...mapState("kyc", {
      userKycInfoCheck: (state) => state.userKycInfoCheck,
    }),
    kycCertified() {
      let flag = false;
      try {
        if (this.userKycInfoCheck.currKycLevel) {
          flag = Number(this.userKycInfoCheck.currKycLevel) > 0;
        } else if (this.userKycInfoCheck.currUserLevel) {
          flag = Number(this.userKycInfoCheck.currUserLevel) > 0;
        }
      } catch (e) {
        console.log(e);
      }
      return flag;
    },
  },
  watch: {
    menuState: {
      immediate: true,
      deep: true,
      handler(newVal) {
        // if(newVal  === true){
        localStorage.getItem("token")
          ? (this.token = true)
          : (this.token = false);
        localStorage.getItem("email")
          ? (this.email = AES_Decrypt(localStorage.getItem("email")))
          : (this.email = "");
        // }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
#routerMenu {
  position: relative;
  .routerMenu_line {
    display: flex;
    align-items: center;
    margin-top: 0.24rem;
    cursor: pointer;
    .lineIcon {
      display: flex;
      img {
        width: 0.3rem;
      }
    }
    .lineName {
      font-size: 0.16rem;
      font-family: Regular;
      font-weight: 400;
      color: #6e7687;
      margin-left: 0.12rem;
    }
    .lineRight {
      margin-left: auto;
      display: flex;
      align-items: center;
      p {
        font-size: 0.15rem;
        font-family: Regular;
        font-weight: 400;
        color: #6e7687;
        margin-right: 0.12rem;
      }
      .email {
        margin-right: 0.12rem;
        font-size: 0.15rem;
        font-family: Regular;
        font-weight: 400;
        color: #c2c2c2;
      }
      div {
        display: flex;
      }
      img {
        // width: 0.6rem;
        // height: ;
        height: 0.2rem;
      }
    }
    &:nth-of-type(1) {
      margin-top: 0.2rem;
    }
  }
  .routerMenu_isLogo {
    width: 100%;
    height: 2.26rem;
    // text-align: center;
    border-radius: 0.12rem;
    border: 1px solid #d9d9d9;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    > img {
      width: 0.58rem;
      height: 0.5rem;
      margin-top: 0.18rem;
    }
    h2 {
      font-size: 0.2rem;
      font-family: Semibold;
      color: #031633;
      line-height: 0.25rem;
      font-weight: 500;
      margin: 0.2rem 0 0.06rem 0;
    }
    p {
      font-size: 0.13rem;
      font-family: Regular;
      font-weight: 400;
      color: #6e7687;
    }
    > div {
      width: 90%;
      background: linear-gradient(88.06deg, #0059da 0%, #1bb2f2 100%);
      border-radius: 0.3rem;
      height: 0.58rem;
      font-size: 0.17rem;
      margin-top: 0.17rem;
      text-align: center;
      line-height: 0.58rem;
      color: #fff;
      font-family: Regular;
      font-weight: 400;
      position: relative;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon {
        width: 0.2rem;
        // height: .14rem;
        margin-left: 0.1rem;
        span {
          height: 0.16rem;
          margin-top: 0.02rem;
        }
      }
    }
  }
  .routerMenu_history {
    width: 100%;
    height: 0.8rem;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e2e1e5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.31rem 0 0.24rem;
    cursor: pointer;
    margin-top: 0.12rem;
    .alone {
      font-family: Semibold !important;
      font-weight: 600 !important;
      font-size: 0.16rem !important;
      color: #031633 !important;
    }
    .lineName {
      margin-left: 0.16rem;
      flex: 1;
      p:first-child {
        font-family: Semibold;
        font-weight: 600;
        font-size: 0.17rem;
        color: #063376;
        line-height: 0.17rem;
      }
      p:last-child {
        font-family: Regular;
        font-weight: 400;
        color: #c0c0c2;
        line-height: 17px;
        font-size: 0.15rem;
        // margin-top: .04rem;
      }
    }
    .lineIcon {
      img {
        width: 0.36rem;
      }
    }
    .lineRight {
      img {
        // width: .1rem;
        height: 0.2rem;
      }
    }
  }
  .routerMenu_loginOut {
    width: 100%;
    height: 100%;
    background: #00000080;
    position: fixed;
    left: 0;
    top: 0;
    .content {
      max-width: 3.5rem;
      background: #ffffff;
      border-radius: 16px;
      position: absolute;
      left: 50%;
      top: 30%;
      transform: translate(-50%, 30%);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.32rem 0.16rem 0.32rem;
      box-sizing: border-box;

      h2 {
        text-align: center;
        font-style: normal;
        font-weight: 400;
        color: #6e7687;
        line-height: 0.31rem;
        font-size: 0.16rem;
        font-family: Regular;
        font-weight: 400;
      }
      > div {
        width: 3.3rem;
        height: 0.6rem;
        display: flex;
        margin-top: 0.2rem;
        justify-content: center;
        align-items: center;
        button {
          width: 1.5rem;
          height: 0.5rem;
          background: #e55643;
          border-radius: 0.29rem;
          text-align: center;
          line-height: 0.49rem;
          font-size: 0.16rem;
          color: #ffffff;
          border: none;
          font-family: Regular;
          font-weight: 400;
          margin-top: 0.05rem;
          margin-right: 0.13rem;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          .icon {
            span {
              height: 0.2rem;
            }
          }
        }
        p {
          width: 1.5rem;
          height: 0.5rem;
          text-align: center;
          color: #031633;
          font-family: Regular;
          font-weight: 400;
          font-size: 0.16rem;
          line-height: 0.49rem;
          border: 1px solid #eeeeee;
          border-radius: 0.25rem;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
